<template>
  <div class="row" :class="{ 'row--suffix': $slots.suffix, drag: dragFlag }">
    <div class="fold" v-if="$slots.fold">
      <slot name="fold"></slot>
    </div>
    <div class="prefix" v-if="$slots.prefix">
      <slot name="prefix"></slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <div class="suffix" v-if="$slots.suffix">
      <slot name="suffix"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Row",
  props: {
    dragFlag: Boolean
  }
}
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  align-items: center;
  background-color: #fff;
  margin-bottom: 8px;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  user-select: none;
  &:hover {
    .suffix {
      visibility: visible;
    }
    .prefix {
      color: #409eff;
    }
  }
  &.drag {
    cursor: grab;
  }
  &.row--suffix {
    padding-right: 6px;
  }
  .fold {
    margin-right: 3px;
  }
  .prefix {
    font-size: 18px;
    padding: 2px;
    margin-right: 3px;
  }
  .content {
    flex: 1 1;
    margin-right: 8px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .suffix {
    padding: 2px;
    cursor: pointer;
    font-weight: bold;
    visibility: hidden;
    &:hover {
      color: #409eff;
    }
  }
}
</style>
